import { render, staticRenderFns } from "./CardResumeCompanyDetails.vue?vue&type=template&id=7fd5d63a&scoped=true&"
import script from "./CardResumeCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./CardResumeCompanyDetails.vue?vue&type=script&lang=js&"
import style0 from "./CardResumeCompanyDetails.vue?vue&type=style&index=0&id=7fd5d63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd5d63a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
